import $ from "jquery";
import { showMessage, initTinymce } from "./main";
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "htmlcontentDetail")
        return;
    init();
});
function init() {
    initTinymce('Content', 300);
    initShowImageSelectModal();
    initShowFileSelectModal();
    initUploadFile();
}
function initShowImageSelectModal() {
    $("#selectImage").off('click');
    $('#selectImage').on('click', function () {
        $('#uploadFileModal').modal('show');
    });
}
function initShowFileSelectModal() {
    $("#selectFile").off('click');
    $('#selectFile').on('click', function () {
        var fileInfo = $('#FileInfo')[0];
        var fileInput = document.getElementById("FileInput");
        // Skryť informáciu o uloženom súbore
        if (fileInfo) {
            fileInfo.style.display = "none";
        }
        // Zobraziť vstup pre nahranie nového súboru
        if (fileInput) {
            fileInput.style.display = "block";
        }
    });
}
function initUploadFile() {
    $('#uploadFile').on('click', function () {
        var fileInput = $('#imageForDownload')[0];
        var file = fileInput.files[0];
        var id = $('#Id').val();
        var languageCode = $('#LanguageCode').val();
        if (file) {
            var formData = new FormData();
            formData.append("image", file);
            formData.append("id", id.toString());
            formData.append("languageCode", languageCode.toString());
            $.ajax({
                url: '/HtmlContent/UploadImage',
                type: 'POST',
                //data: JSON.stringify(formData), 
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#uploadFileModal').modal('hide');
                    $('#ImageFileName').val(response.fileName);
                    $('#OriginalImageFileName').val(response.originalImageFileName);
                    $('#ImageUrl').val(response.imageUrl);
                    $('#imgImageUrl').attr('src', response.imageUrl);
                },
                error: function (xhr) {
                    var _a;
                    var msg = ((_a = xhr === null || xhr === void 0 ? void 0 : xhr.responseJSON) === null || _a === void 0 ? void 0 : _a.message) || "Chyba pri nahrávaní súboru.";
                    showMessage(msg, "Chyba!");
                }
            });
        }
        else {
            showMessage("Prosím, vyberte súbor.", "Chyba!");
        }
    });
}
//# sourceMappingURL=htmlContentDetail.js.map